/**
 * Sensitivity tiers, derived from field TYPE — never from a flag someone can
 * forget to set. PLAN.md 3.2.
 *
 *   Tier 2: may sit in the server-side draft, deleted on completion.
 *   Tier 3: browser only. The Worker rejects any request carrying a Tier 3 value.
 */
import type { FieldType } from './ast';

export type Tier = 2 | 3;

const TIER3_TYPES: ReadonlySet<FieldType> = new Set<FieldType>(['aadhaar', 'pan', 'tan']);

export function tierOf(type: FieldType): Tier {
  return TIER3_TYPES.has(type) ? 3 : 2;
}

export function isTier3(type: FieldType): boolean {
  return TIER3_TYPES.has(type);
}
